import React from 'react';
import { motion } from 'framer-motion';
import '../styles/v3-pages.css';
import { MacWindow } from './motifs';
import linkedinLogo from '../assets/logos/linkedin.svg';
import githubLogo from '../assets/logos/github.svg';
import instagramLogo from '../assets/logos/instagram.svg';
import youtubeLogo from '../assets/logos/youtube.svg';

function Contact() {
  const calendlyUrl = 'https://calendly.com/vijaykumarkagupati/30min';

  const staggerConfig = {
    initial: { opacity: 0, y: 12 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] }
  };

  return (
    <section className="v3-contact" id="contact" data-aos="fade-up" data-aos-duration="1000">
      <motion.div className="v3-contact-eyebrow" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0 }}>
        [ CONTACT · BOOK A SLOT ]
      </motion.div>

      <motion.h1 className="v3-contact-title" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.06 }}>
        Let's talk.
      </motion.h1>

      <motion.p className="v3-contact-intro" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.12 }}>
        Ready to discuss your next project or opportunity? Schedule a time for a Google Meet and let's connect!
      </motion.p>

      <motion.div className="v3-contact-ctas" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.18 }}>
        <a href="mailto:vijaykumarkagupati@gmail.com" className="v3-contact-cta-primary">
          → EMAIL ME
        </a>
        <a href="https://www.linkedin.com/in/vijaykagupati/" target="_blank" rel="noopener noreferrer" className="v3-contact-cta-ghost">
          LINKEDIN ↗
        </a>
      </motion.div>

      <motion.div className="v3-contact-calendly-wrapper" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.24 }}>
        <MacWindow title="book-30min.cal">
          <iframe
            src={calendlyUrl}
            width="100%"
            height="700"
            frameBorder="0"
            className="v3-contact-calendly"
            title="Schedule a meeting with Vijay"
          />
        </MacWindow>
      </motion.div>

      <motion.div className="v3-contact-socials" {...staggerConfig} transition={{ ...staggerConfig.transition, delay: 0.30 }}>
        <a href="https://www.linkedin.com/in/vijaykagupati/" className="v3-contact-social-icon" title="LinkedIn" target="_blank" rel="noopener noreferrer">
          <img src={linkedinLogo} alt="LinkedIn" style={{ width: '18px', height: '18px' }} />
        </a>
        <a href="https://github.com/VijayKagupati" className="v3-contact-social-icon" title="GitHub" target="_blank" rel="noopener noreferrer">
          <img src={githubLogo} alt="GitHub" style={{ width: '18px', height: '18px' }} />
        </a>
        <a href="https://www.youtube.com/@VijayPages" className="v3-contact-social-icon" title="YouTube" target="_blank" rel="noopener noreferrer">
          <img src={youtubeLogo} alt="YouTube" style={{ width: '18px', height: '18px' }} />
        </a>
        <a href="https://www.instagram.com/vijay_pages/" className="v3-contact-social-icon" title="Instagram" target="_blank" rel="noopener noreferrer">
          <img src={instagramLogo} alt="Instagram" style={{ width: '18px', height: '18px' }} />
        </a>
      </motion.div>
    </section>
  );
}

export default Contact;
